
    import Vue from 'vue';
    import Component from "vue-class-component";
    import {
        factory,
        QualificationRecordResultModel, QualificationRecordsClient, ResultError, SetResultAsPassedModel
    } from "@/api-client";
    import {BModal} from "bootstrap-vue";
    import {Prop} from "vue-property-decorator";
    import ErrorsSummary from "@/components/ErrorsSummary.vue";
    import toasts from "@/components/Toasts";

    @Component({
        components: {
            ErrorsSummary
        },
    })
    export default class SetQualificationResultAsPassedModal extends Vue {
        @Prop({required: true})
        modelType!: { new(): SetResultAsPassedModel };
        @Prop({required: true})
        recordId!: string;
        
        result: QualificationRecordResultModel = factory.create(QualificationRecordResultModel);
        validationErrors: ResultError = factory.create(ResultError);

        $refs!: {
            modal: BModal;
        };
        
        public open(result: QualificationRecordResultModel){
            this.validationErrors = factory.create(ResultError);
            this.result = QualificationRecordResultModel.fromJS(result);
            this.$refs.modal.show();
        }

        async submit() {
            const model = factory.create(this.modelType);
            model.recordId = this.recordId;
            model.seafarerId = this.result.seafarer!.id;
            model.certificateNumber = this.result.certificateNumber;
            console.log(model.certificateNumber);
            await new QualificationRecordsClient().setResultPassed(model).then(() => {
                this.$emit("results-updated");
                this.close();
                toasts.success(this.$ls.Global_Toast_SaveSuccess);
            }).catch(error => this.setValidationErrors(error, this.$ls.Global_Toast_FormSaveFailure));
        }

        close(){
            this.$refs.modal.hide();
        }
    }
